import axios from "axios";
import { AuthPersistenceService } from "../hooks/auth";

export const setupInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      config.baseURL = process.env.REACT_APP_API_URL;
      const token = AuthPersistenceService.getAuthToken();

      if (token) {
        config.headers!.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const token = AuthPersistenceService.getAuthToken();

      if (error.response.status === 401 && token) {
        AuthPersistenceService.removeAuthToken();
        window.location.href = "/logout";
      }
      return Promise.reject(error);
    }
  );
};
